import DOMPurify from 'dompurify';
import styled from 'styled-components';

interface MessageTextProps {
  htmlData: string;
}

export function MessageText(props: MessageTextProps) {
  return (
    // eslint-disable-next-line no-restricted-syntax -- Sanitized by backend, returned only by BE
    <MessageTextDiv dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.htmlData ?? '')}} />
  );
}

// Important due to styled html elements
// eslint-disable-next-line eag/no-css-property
const MessageTextDiv = styled.div`
  font-size: ${({theme}) => theme.fontSizes.text.small} !important;
  color: ${({theme}) => theme.colors.text.primary} !important;
  background-color: transparent !important;

  * {
    background-color: transparent !important;
    color: ${({theme}) => theme.colors.text.primary} !important;
  }

  table {
    border-collapse: unset;

    a {
      display: flex;
      width: max-content;
      justify-content: center;
      pointer-events: none;
    }
  }
`;
